angular.module('TInv.consts', []
).factory('Consts', function () {
    var x = null; // campi che il nostro form non modifica, ma servono per l'ordine degli XML esterni
    return {
        // XML base structure
        baseFattura: {
            FatturaElettronicaHeader: {                        // 1
                DatiTrasmissione: {                            // 1.1
                    IdTrasmittente: x,                         // 1.1.1
                    ProgressivoInvio: x,                       // 1.1.2
                    FormatoTrasmissione: 'FPA12',              // 1.1.3
                    CodiceDestinatario: '',                    // 1.1.4
                    ContattiTrasmittente: x,                   // 1.1.5
                    PECDestinatario: '',                       // 1.1.6
                },
                CedentePrestatore: x,
                RappresentanteFiscale: x,                      // 1.3
                CessionarioCommittente: {                      // 1.4
                    DatiAnagrafici: {                          // 1.4.1
                        IdFiscaleIVA: {                        // 1.4.1.1
                            IdPaese: 'IT',                     // 1.4.1.1.1
                            IdCodice: '',                      // 1.4.1.1.2
                        },
                        CodiceFiscale: '',                     // 1.4.1.2
                        Anagrafica: {                          // 1.4.1.3
                            Denominazione: '',                 // 1.4.1.3.1
                            // Nome: '',                       // 1.4.1.3.2
                            // Cognome: '',                    // 1.4.1.3.3
                            // Titolo: '',                     // 1.4.1.3.4
                            // CodEORI: '',                    // 1.4.1.3.5
                        },
                    },
                    Sede: {                                    // 1.4.2
                        Indirizzo: '',                         // 1.4.2.1
                        NumeroCivico: '',                      // 1.4.2.2
                        CAP: '',                               // 1.4.2.3
                        Comune: '',                            // 1.4.2.4
                        Provincia: '',                         // 1.4.2.5
                        Nazione: 'IT',                         // 1.4.2.6
                    },
                },
                TerzoIntermediarioOSoggettoEmittente: x,       // 1.5
                SoggettoEmittente: x,                          // 1.6
            },
            FatturaElettronicaBody: {                          // 2
                DatiGenerali: {                                // 2.1
                    DatiGeneraliDocumento: {                   // 2.1.1
                        TipoDocumento: 'TD01',                 // 2.1.1.1 (tipiDocumento)
                        Divisa: 'EUR',                         // 2.1.1.2
                        Data: '',                              // 2.1.1.3
                        Numero: '',                            // 2.1.1.4
                        DatiRitenuta: {                        // 2.1.1.5
                            TipoRitenuta: '',                  // 2.1.1.5.1
                            ImportoRitenuta: '',               // 2.1.1.5.2
                            AliquotaRitenuta: '',              // 2.1.1.5.3
                            CausalePagamento: '',              // 2.1.1.5.4 (causaliRitenuta)
                        },
                        DatiBollo: {                           // 2.1.1.6
                            BolloVirtuale: false,              // 2.1.1.6.1
                            ImportoBollo: x,                   // 2.1.1.6.2
                        },
                        DatiCassaPrevidenziale: [              // 2.1.1.7
                            //{
                            //    TipoCassa: '',                  // 2.1.1.7.1
                            //    AlCassa: '',                    // 2.1.1.7.2
                            //    ImportoContributoCassa: '',     // 2.1.1.7.3
                            //    ImponibileCassa: '',            // 2.1.1.7.4
                            //    AliquotaIVA: '',                // 2.1.1.7.5
                            //    Ritenuta: '',                   // 2.1.1.7.6
                            //    Natura: '',                     // 2.1.1.7.7
                            //    RiferimentoAmministrazione: '', // 2.1.1.7.8
                            //}
                        ],
                        ScontoMaggiorazione: x,                // 2.1.1.8
                        // {
                        //     Tipo: '',                       // 2.1.1.8.1
                        //     Percentuale: '',                // 2.1.1.8.2
                        //     Importo: '',                    // 2.1.1.8.3
                        // },
                        ImportoTotaleDocumento: 0,             // 2.1.1.9
                        Arrotondamento: x,                     // 2.1.1.10
                        Causale: '',                           // 2.1.1.11
                        Art73: false,                          // 2.1.1.12
                    },
                    DatiOrdineAcquisto: [                     // 2.1.2
                        //{
                        //RiferimentoNumeroLinea: x,           // 2.1.2.1
                        //IdDocumento: '',                     // 2.1.2.2
                        //Data: '',                            // 2.1.2.3
                        //NumItem: '',                         // 2.1.2.4
                        //CodiceCommessaConvenzione: '',       // 2.1.2.5
                        //CodiceCUP: '',                       // 2.1.2.6
                        //CodiceCIG: '',                       // 2.1.2.7
                        //}
                    ],
                    DatiContratto: [],                         // 2.1.3
                    DatiConvenzione: [],                       // 2.1.4
                    DatiRicezione: [],                         // 2.1.5
                    DatiFattureCollegate: [],                  // 2.1.6
                    DatiDDT: [                                 // 2.1.8
                        // {
                        //    NumeroDDT: '',                   // 2.1.8.1
                        //    DataDDT: '',                     // 2.1.8.2
                        //    RiferimentoNumeroLinea: '',      // 2.1.8.3
                        // }
                    ],
                },
                DatiBeniServizi: {                             // 2.2
                    DettaglioLinee: [],                        // 2.2.1
                    DatiRiepilogo: [],                         // 2.2.2
                },
                // DatiVeicoli: {...},                         // 2.3
                DatiPagamento: [                               // 2.4
                //{
                //    CondizioniPagamento: 'TP02',               // 2.4.1
                //    DettaglioPagamento: {                      // 2.4.2
                //        Beneficiario: '',                      // 2.4.2.1
                //      ModalitaPagamento: 'MP05',               // 2.4.2.2
                //        DataRiferimentoTerminiPagamento: x,    // 2.4.2.3
                //        GiorniTerminiPagamento: x,             // 2.4.2.4
                //       DataScadenzaPagamento: '',              // 2.4.2.5
                //        ImportoPagamento: 0,                   // 2.4.2.6
                //        CodUfficioPostale: x,                  // 2.4.2.7
                //        CognomeQuietanzante: x,                // 2.4.2.8
                //        NomeQuietanzante: x,                   // 2.4.2.9
                //        CFQuietanzante: x,                     // 2.4.2.10
                //        TitoloQuietanzante: x,                 // 2.4.2.11
                //        IstitutoFinanziario: x,                // 2.4.2.12
                //        IBAN: '',                              // 2.4.2.13
                //        ABI: x,                                // 2.4.2.14
                //       CAB: x,                                 // 2.4.2.15
                //        BIC: '',                               // 2.4.2.16
                //        ScontoPagamentoAnticipato: x,          // 2.4.2.17
                //        DataLimitePagamentoAnticipato: x,      // 2.4.2.18
                //       PenalitaPagamentiRitardati: x,          // 2.4.2.19
                //        DataDecorrenzaPenale: x,               // 2.4.2.20
                //        CodicePagamento: x,                    // 2.4.2.21
                //    },
                //},
                ],
                Allegati: {                                    // 2.5
                    NomeAttachment: '',                        // 2.5.1
                    AlgoritmoCompressione: x,                  // 2.5.2
                    FormatoAttachment: 'PDF',                  // 2.5.3
                    DescrizioneAttachment: '',                 // 2.5.4
                    Attachment: null,                          // 2.5.5
                },
            },
            $tipo: 'B2B',                                      // FatturaPA / B2B
            $EsigibilitaIVA: 'I',                              // serve nel riepilogo
            $RiferimentoNormativo: {},                         // mappa Natura→Riferimento per riepilogo
        },
        baseCorrispettivo: {
            DatiFatturaHeader: {
                ProgressivoInvio: x
            },
            DTE: {
                CedentePrestatoreDTE: {
                    IdentificativiFiscali: x
                },
                CessionarioCommittenteDTE: [{
                    IdentificativiFiscali: {
                        IdFiscaleIVA: {
                            IdPaese: 'XX',
                            IdCodice: 'COR10'
                        }
                    },
                    DatiFatturaBodyDTE: [
                        // Bodies
                    ]
                }]
            }
        },
        baseDatiFatturaBodyDTE: {
            DatiGenerali: {
                TipoDocumento: 'TD12',
                Data: '',
                Numero: ''
            },
            DatiRiepilogo: [
                // Riepilogo(s)
            ]
        },
        baseCedentePrestatore: {                       // 1.2
            DatiAnagrafici: {                          // 1.2.1
                IdFiscaleIVA: {                        // 1.2.1.1
                    IdPaese: 'IT',                     // 1.2.1.1.1
                    IdCodice: '',                      // 1.2.1.1.2
                },
                CodiceFiscale: '',                     // 1.2.1.2
                Anagrafica: {                          // 1.2.1.3
                    Denominazione: '',                 // 1.2.1.3.1
                    Nome: x,                           // 1.2.1.3.2
                    Cognome: x,                        // 1.2.1.3.3
                    Titolo: x,                         // 1.2.1.3.4
                    CodEORI: x,                        // 1.2.1.3.5
                },
                AlboProfessionale: x,                  // 1.2.1.4
                ProvinciaAlbo: x,                      // 1.2.1.5
                NumeroIscrizioneAlbo: x,               // 1.2.1.6
                DataIscrizioneAlbo: x,                 // 1.2.1.7
                RegimeFiscale: x,                      // 1.2.1.8
            },
            Sede: {                                    // 1.2.2
                Indirizzo: '',                         // 1.2.2.1
                NumeroCivico: '',                      // 1.2.2.2
                CAP: '',                               // 1.2.2.3
                Comune: '',                            // 1.2.2.4
                Provincia: '',                         // 1.2.2.5
                Nazione: 'IT',                         // 1.2.2.6
            },
            StabileOrganizzazione: {                   // 1.2.3
                Indirizzo: x,                          // 1.2.3.1
                NumeroCivico: x,                       // 1.2.3.2
                CAP: x,                                // 1.2.3.3
                Comune: x,                             // 1.2.3.4
                Provincia: x,                          // 1.2.3.5
                Nazione: x,                            // 1.2.3.6
            },
            IscrizioneREA: {                           // 1.2.4
                Ufficio: '',                           // 1.2.4.1
                NumeroREA: '',                         // 1.2.4.2
                CapitaleSociale: x,                    // 1.2.4.3
                SocioUnico: x,                         // 1.2.4.4
                StatoLiquidazione: x,                  // 1.2.4.5
            },
            Contatti : {
                Telefono : '',
                Fax : '',
                Email : '',
            },
            RiferimentoAmministrazione: x,
        },
        baseLinea: {                                           // 2.2.1
            NumeroLinea: 1,                                    // 2.2.1.1
            TipoCessionePrestazione: x,                        // 2.2.1.2
            CodiceArticolo: {                                  // 2.2.1.3
                CodiceTipo: x,                                 // 2.2.1.3.1
                CodiceValore: x,                               // 2.2.1.3.2
            },
            Descrizione: '',                                   // 2.2.1.4
            Quantita: 1,                                       // 2.2.1.5
            UnitaMisura: '',                                   // 2.2.1.6
            DataInizioPeriodo: x,                              // 2.2.1.7
            DataFinePeriodo: x,                                // 2.2.1.8
            PrezzoUnitario: 0,                                 // 2.2.1.9
            ScontoMaggiorazione: {                             // 2.2.1.10
                Tipo: x,                                       // 2.2.1.10.1
                Percentuale: x,                                // 2.2.1.10.2
                Importo: x,                                    // 2.2.1.10.3
            },
            PrezzoTotale: 0,                                   // 2.2.1.11
            AliquotaIVA: 22,                                   // 2.2.1.12
            Ritenuta: false,                                   // 2.2.1.13
            Natura: '',                                        // 2.2.1.14
            RiferimentoAmministrazione: x,                     // 2.2.1.15
            AltriDatiGestionali: {                             // 2.2.1.16
                TipoDato: x,                                   // 2.2.1.16.1
                RiferimentoTesto: x,                           // 2.2.1.16.2
                RiferimentoNumero: x,                          // 2.2.1.16.3
                RiferimentoData: x,                            // 2.2.1.16.4
            }
        },
        baseRiepilogo: {                                       // 2.2.2
            AliquotaIVA: 22,                                   // 2.2.2.1
            Natura: '',                                        // 2.2.2.2
            SpeseAccessorie: x,                                // 2.2.2.3
            Arrotondamento: x,                                 // 2.2.2.4
            ImponibileImporto: 0,                              // 2.2.2.5
            Imposta: 0,                                        // 2.2.2.6
            EsigibilitaIVA: '',                                // 2.2.2.7
            RiferimentoNormativo: '',                          // 2.2.2.8
            Data: '',                                          // 2.42.52.3.1
            TotalePercorso: '',                                // 2.3.2
        },
        baseRiepilogoCorrispettivi: {
            ImponibileImporto: 0,
            DatiIVA: {
                Imposta: 0,
                Aliquota: 22
            },
            Natura: x
        },
        baseDatiOrdineAcquisto: {                              //2.1.2
            RiferimentoNumeroLinea: x,                         // 2.1.2.1
            IdDocumento: '',                                   // 2.1.2.2
            Data: '',                                          // 2.1.2.3
            NumItem: '',                                       // 2.1.2.4
            CodiceCommessaConvenzione: '',                     // 2.1.2.5
            CodiceCUP: '',                                     // 2.1.2.6
            CodiceCIG: '',                                     // 2.1.2.7
        },
        baseDDT: {                                             // 2.1.8
            NumeroDDT: '',                                     // 2.1.8.1
            DataDDT: '',                                       // 2.1.8.2
            RiferimentoNumeroLinea: 0,                         // 2.1.8.3
        },
        baseCassa: {
            TipoCassa: 'TC01',                                 // 2.1.1.7.1
            AlCassa: 0,                                        // 2.1.1.7.2
            ImportoContributoCassa: 0,                         // 2.1.1.7.3
            ImponibileCassa: x,                                // 2.1.1.7.4
            AliquotaIVA: 22,                                   // 2.1.1.7.5
            Ritenuta: x,                                       // 2.1.1.7.6
            Natura: x,                                         // 2.1.1.7.7
            RiferimentoAmministrazione: x,                     // 2.1.1.7.8
        },
        basePagamento: {                                       // 2.4
            CondizioniPagamento: 'TP02',                       // 2.4.1
            DettaglioPagamento: [
                //{                                             // 2.4.2
                //Beneficiario: '',                             // 2.4.2.1
                //ModalitaPagamento: 'MP05',                    // 2.4.2.2
                //DataRiferimentoTerminiPagamento: x,           // 2.4.2.3
                //GiorniTerminiPagamento: x,                    // 2.4.2.4
                //DataScadenzaPagamento: x,                     // 2.4.2.5
                //ImportoPagamento: 0,                          // 2.4.2.6
                //CodUfficioPostale: x,                         // 2.4.2.7
                //CognomeQuietanzante: x,                       // 2.4.2.8
                //NomeQuietanzante: x,                          // 2.4.2.9
                //CFQuietanzante: x,                            // 2.4.2.10
                //TitoloQuietanzante: x,                        // 2.4.2.11
                //IstitutoFinanziario: x,                       // 2.4.2.12
                //IBAN: '',                                     // 2.4.2.13
                //ABI: x,                                       // 2.4.2.14
                //CAB: x,                                       // 2.4.2.15
                //BIC: '',                                      // 2.4.2.16
                //ScontoPagamentoAnticipato: x,                 // 2.4.2.17
                //DataLimitePagamentoAnticipato: x,             // 2.4.2.18
                //PenalitaPagamentiRitardati: x,                // 2.4.2.19
                //DataDecorrenzaPenale: x,                      // 2.4.2.20
                //CodicePagamento: x,                           // 2.4.2.21
            //}
            ],
        },
        baseDettaglioPagamento: {
            Beneficiario: '',                              // 2.4.2.1
            ModalitaPagamento: 'MP08',                     // 2.4.2.2
            DataRiferimentoTerminiPagamento: x,            // 2.4.2.3
            GiorniTerminiPagamento: x,                     // 2.4.2.4
            DataScadenzaPagamento: x,                      // 2.4.2.5
            ImportoPagamento: 0,                           // 2.4.2.6
            CodUfficioPostale: x,                          // 2.4.2.7
            CognomeQuietanzante: x,                        // 2.4.2.8
            NomeQuietanzante: x,                           // 2.4.2.9
            CFQuietanzante: x,                             // 2.4.2.10
            TitoloQuietanzante: x,                         // 2.4.2.11
            IstitutoFinanziario: x,                        // 2.4.2.12
            IBAN: '',                                      // 2.4.2.13
            ABI: x,                                        // 2.4.2.14
            CAB: x,                                        // 2.4.2.15
            BIC: '',                                       // 2.4.2.16
            ScontoPagamentoAnticipato: x,                  // 2.4.2.17
            DataLimitePagamentoAnticipato: x,              // 2.4.2.18
            PenalitaPagamentiRitardati: x,                 // 2.4.2.19
            DataDecorrenzaPenale: x,                       // 2.4.2.20
            CodicePagamento: x,                            // 2.4.2.21
        },
        // multi-value types
        ruoli: {
            USER: 'Utente',
            MANAGER: 'Manager',
        },
        ruoliAdmin: {
            USER: 'Utente',
            MANAGER: 'Manager',
            ADMIN: 'Amministratore',
        },
        regimi: {
            RF01: 'RF01',
            RF02: 'RF02',
            RF03: 'RF03',
            RF04: 'RF04',
            RF05: 'RF05',
            RF06: 'RF06',
            RF07: 'RF07',
            RF08: 'RF08',
            RF09: 'RF09',
            RF10: 'RF10',
            RF11: 'RF11',
            RF12: 'RF12',
            RF13: 'RF13',
            RF14: 'RF14',
            RF15: 'RF15',
            RF16: 'RF16',
            RF17: 'RF17',
            RF18: 'RF18',
            RF19: 'RF19',
        },
        tipiDocumento: {
            TD01: 'fattura',
            TD02: 'acconto/anticipo su fattura',
            TD03: 'acconto/anticipo su parcella',
            TD04: 'nota di credito',
            TD05: 'nota di debito',
            TD06: 'parcella',
            TD16: 'integrazione fattura reverse charge interno',
            TD17: 'integrazione/autofattura per acquisto servizi dall\'estero',
            TD18: 'integrazione per acquisto di beni intracomunitari',
            TD19: 'integrazione/autofattura per acquisto di beni ex art.17 c.2 DPR 633/72',
            TD20: 'autofattura per regolarizzazione e integrazione delle fatture',
            TD21: 'autofattura per splafonamento',
            TD22: 'estrazione beni da Deposito IVA',
            TD23: 'estrazione beni da Deposito IVA con versamento dell\'IVA',
            TD24: 'fattura differita di cui all\'art.21, comma 4, lett. a)',
            TD25: 'fattura differita di cui all\'art.21, comma 4, terzo periodo lett. b)',
            TD26: 'cessione di beni ammortizzabili e per passaggi interni (ex art.36 DPR 633/72)',
            TD27: 'fattura per autoconsumo o per cessioni gratuite senza rivalsa',
        },
        tipiRitenuta: {
            RT01: 'persone fisiche',
            RT02: 'persone giuridiche',
            RT03: 'contributo INPS',
            RT04: 'contributo ENASARCO',
            RT05: 'contributo ENPAM',
            RT06: 'altro contributo previdenziale',
        },
        tipiEsigibilitaIVA: {
            I: 'IVA ad esigibilità immediata',
            D: 'IVA ad esigibilità differita',
            S: 'scissione dei pagamenti',
        },
        tipiPagamento: {
            TP01: 'pagamento a rate',
            TP02: 'pagamento completo',
            TP03: 'anticipo',
        },
        tipiCassa: {
            TC01: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
            TC02: 'Cassa previdenza dottori commercialisti',
            TC03: 'Cassa previdenza e assistenza geometri',
            TC04: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
            TC05: 'Cassa nazionale del notariato',
            TC06: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
            TC07: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
            TC08: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
            TC09: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
            TC10: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
            TC11: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
            TC12: 'Ente nazionale previdenza e assistenza impiegati dell\'agricoltura (ENPAIA)',
            TC13: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
            TC14: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
            TC15: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
            TC16: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
            TC17: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
            TC18: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
            TC19: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
            TC20: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
            TC21: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
            TC22: 'INPS',
        },
        modalitaPagamento: {
            MP01: 'contanti',
            MP02: 'assegno',
            MP03: 'assegno circolare',
            MP04: 'contanti presso Tesoreria',
            MP05: 'bonifico',
            MP06: 'vaglia cambiario',
            MP07: 'bollettino bancario',
            MP08: 'carta di pagamento',
            MP09: 'RID',
            MP10: 'RID utenze',
            MP11: 'RID veloce',
            MP12: 'RIBA',
            MP13: 'MAV',
            MP14: 'quietanza erario',
            MP15: 'giroconto su conti di contabilità speciale',
            MP16: 'domiciliazione bancaria',
            MP17: 'domiciliazione postale',
            MP18: 'bollettino di c/c postale',
            MP19: 'SEPA Direct Debit',
            MP20: 'SEPA Direct Debit CORE',
            MP21: 'SEPA Direct Debit B2B',
            MP22: 'Trattenuta su somme già riscosse',
            MP23: 'PagoPA',
        },
        nature: {
            'N1': 'escluse ex art. 15',
            'N2': 'non soggette',
            'N2.1': 'Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72',
            'N2.2': 'Non soggette - altri casi',
            'N3': 'non imponibili',
            'N3.1': 'Non Imponibili - esportazioni',
            'N3.2': 'Non Imponibili – cessioni intracomunitarie',
            'N3.3': 'non imponibili – cessioni verso San Marino',
            'N3.4': 'non imponibili – operazioni assimilate alle cessioni all’esportazione',
            'N3.5': 'non imponibili – a seguito di dichiarazioni d’intento',
            'N3.6': 'non imponibili - altre operazioni che non concorrono alla formazione del plafond',
            'N4': 'esenti',
            'N5': 'regime del margine/IVA non esposta in fattura',
            'N6': 'Inversione contabile (reverse)',
            'N6.1': 'Inversione contabile – cessione di rottami e altri materiali di recupero',
            'N6.2': 'Inversione contabile – cessione di oro e argento puro',
            'N6.3': 'Inversione contabile – subappalto nel settore edile',
            'N6.4': 'Inversione contabile – cessione di fabbricati',
            'N6.5': 'Inversione contabile – cessione di telefoni cellulari',
            'N6.6': 'Inversione contabile – cessione di prodotti elettronici',
            'N6.7': 'Inversione contabile – prestazioni comparto edile e settori connessi',
            'N6.8': 'Inversione contabile – operazioni settore energetico',
            'N6.9': 'Inversione contabile - altri casi',
            'N7': 'IVA assolta in altro stato UE',
        },
        causaliRitenuta: { // 2.1.1.5.4
            A:  'A: prestazioni di lavoro autonomo rientranti nell’esercizio di arte o professione abituale',
            B:  'B: utilizzazione economica, da parte dell’autore o dell’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule o informazioni relativi ad esperienze acquisite in campo industriale, commerciale o scientifico',
            C:  'C: utili derivanti da contratti di associazione in partecipazione e da contratti di cointeressenza, quando l’apporto è costituito esclusivamente dalla prestazione di lavoro',
            D:  'D: utili spettanti ai soci promotori ed ai soci fondatori delle società di capitali',
            E:  'E: levata di protesti cambiari da parte dei segretari comunali',
            G:  'G: indennità corrisposte per la cessazione di attività sportiva professionale',
            H:  'H: indennità corrisposte per la cessazione dei rapporti di agenzia delle persone fisiche e delle società di persone con esclusione delle somme maturate entro il 31 dicembre 2003, già imputate per competenza e tassate come reddito d’impresa',
            I:  'I: indennità corrisposte per la cessazione da funzioni notarili',
            L:  'L: redditi derivanti dall’utilizzazione economica di opere dell’ingegno, di brevetti industriali e di processi, formule e informazioni relativi a esperienze acquisite in campo industriale, commerciale o scientifico, che sono percepiti dagli aventi causa a titolo gratuito (ad es. eredi e legatari dell’autore e inventore)',
            L1: 'L1: redditi derivanti dall’utilizzazione economica di opere dell’ingegno, di brevetti industriali e di processi, formule e informazioni relativi a esperienze acquisite in campo industriale, commerciale o scientifico, che sono percepiti da soggetti che abbiano acquistato a titolo oneroso i diritti alla loro utilizzazione',
            M:  'M: prestazioni di lavoro autonomo non esercitate abitualmente',
            M1: 'M1: redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere',
            M2: 'M2: prestazioni di lavoro autonomo non esercitate abitualmente per le quali sussiste l’obbligo di iscrizione alla Gestione Separata ENPAPI',
            N:  'N: indennità di trasferta, rimborso forfetario di spese, premi e compensi erogati:' +
                ' nell’esercizio diretto di attività sportive dilettantistiche;' +
                ' in relazione a rapporti di collaborazione coordinata e continuativa di carattere amministrativo-gestionale di natura non professionale resi a favore di società e associazioni sportive dilettantistiche e di cori, bande e filodrammatiche da parte del direttore e dei collaboratori tecnici',
            O:  'O: prestazioni di lavoro autonomo non esercitate abitualmente, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. INPS n. 104/2001)',
            O1: 'O1: redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. INPS n. 104/2001)',
            P:  'P: compensi corrisposti a soggetti non residenti privi di stabile organizzazione per l’uso o la concessione in uso di attrezzature industriali, commerciali o scientifiche che si trovano nel territorio dello Stato ovvero a società svizzere o stabili organizzazioni di società svizzere che possiedono i requisiti di cui all’art. 15, comma 2 dell’Accordo tra la Comunità europea e la Confederazione svizzera del 26 ottobre 2004 (pubblicato in G.U.C.E. del 29 dicembre 2004 n. L385/30)',
            Q:  'Q: provvigioni corrisposte ad agente o rappresentante di commercio monomandatario',
            R:  'R: provvigioni corrisposte ad agente o rappresentante di commercio plurimandatario',
            S:  'S: provvigioni corrisposte a commissionario',
            T:  'T: provvigioni corrisposte a mediatore',
            U:  'U: provvigioni corrisposte a procacciatore di affari',
            V:  'V: provvigioni corrisposte a incaricato per le vendite a domicilio; provvigioni corrisposte a incaricato per la vendita porta a porta e per la vendita ambulante di giornali quotidiani e periodici (L. 25 febbraio 1987, n. 67)',
            V1: 'V1: redditi derivanti da attività commerciali non esercitate abitualmente (ad esempio, provvigioni corrisposte per prestazioni occasionali ad agente o rappresentante di commercio, mediatore, procacciatore d’affari o incaricato per le vendite a domicilio)',
            W:  'W: corrispettivi erogati nel 2014 per prestazioni relative a contratti d’appalto cui si sono resi applicabili le disposizioni contenute nell’art. 25-ter del D.P.R. n. 600 del 29 settembre 1973',
            X:  'X: canoni corrisposti nel 2004 da società o enti residenti ovvero da stabili organizzazioni di società estere di cui all’art. 26-quater, comma 1, lett. a) e b) del D.P.R. 600 del 29 settembre 1973, a società o stabili organizzazioni di società, situate in altro stato membro dell’Unione Europea in presenza dei requisiti di cui al citato art. 26-quater, del D.P.R. 600 del 29 settembre 1973, per i quali è stato effettuato, nell’anno 2006, il rimborso della ritenuta ai sensi dell’art. 4 del D.Lgs. 30 maggio 2005 n. 143',
            Y:  'Y: canoni corrisposti dal 1° gennaio 2005 al 26 luglio 2005 da società o enti residenti ovvero da stabili organizzazioni di società estere di cui all’art. 26-quater, comma 1, lett. a) e b) del D.P.R. n. 600 del 29 settembre 1973, a società o stabili organizzazioni di società, situate in altro stato membro dell’Unione Europea in presenza dei requisiti di cui al citato art. 26-quater, del D.P.R. n. 600 del 29 settembre 1973, per i quali è stato effettuato, nell’anno 2006, il rimborso della ritenuta ai sensi dell’art. 4 del D.Lgs. 30 maggio 2005 n. 143',
            ZO: 'ZO: titolo diverso dai precedenti',
        },
        tipiXML: { // match sul solo nome campo per semplicità, sperando non ci siano mai collisioni di tipo
            CapitaleSociale: Number,        // 1.2.4.3
            AliquotaIVA: Number,            // 2.2.1.12 + 2.2.2.1 + 2.1.1.7.5
            ImportoBollo: Number,           // 2.1.1.6.2
            AlCassa: Number,                // 2.1.1.7.2
            Arrotondamento: Number,         // 2.1.1.10 + 2.2.2.4
            Art73: Boolean,                 // 2.1.1.12
            DatiCassaPrevidenziale: Array,  // 2.1.1.7
            ImportoContributoCassa: Number, // 2.1.1.7.3
            ImponibileCassa: Number,        // 2.1.1.7.4
            ImportoTotaleDocumento: Number, // 2.1.1.9
            DatiOrdineAcquisto: Array,      // 2.1.2
            DatiDDT: Array,                 // 2.1.8
            RiferimentoNumeroLinea: Number, // 2.1.8.3
            ImponibileImporto: Number,      // 2.2.2.5
            DettaglioLinee: Array,          // 2.2.1
            DatiRiepilogo: Array,           // 2.2.2
            Imposta: Number,                // 2.2.2.6
            NumeroLinea: Number,            // 2.2.1.1
            PrezzoTotale: Number,           // 2.2.1.11
            PrezzoUnitario: Number,         // 2.2.1.9
            Quantita: Number,               // 2.2.1.5
            Ritenuta: Boolean,              // 2.2.1.13
            SpeseAccessorie: Number,        // 2.2.2.3
            DatiPagamento: Array,           // 2.4
            DettaglioPagamento: Array,      // 2.4.2
            ImportoPagamento: Number,       // 2.4.2.6
        },
    };
});